export default "__VITE_ASSET__qg$Dgc6f__";